import normalize from "normalize.css";
import { css } from "styled-components";
import currentTheme from "colorTheme/currentTheme";
import "assets/favicon.ico";
import "assets/favicon-stg.ico";
import "assets/apple-touch-icon.png";

export const globalStyles = css`
  ${normalize} html, body, #root, .cloud-ui-nav-root {
    height: 100%;
  }

  body {
    background-color: ${currentTheme.background};
    color: ${currentTheme.color};
    box-sizing: border-box;
    font-family: ${currentTheme.fontFamily};
    font-size: ${currentTheme.fontSize};
    line-height: ${currentTheme.lineHeight};
  }
  body.no-scroll {
    max-height: 100%;
  }

  body.heroku {
    padding-top: ${currentTheme.herokuBannerHeight};
  }
  body.heroku #side_nav,
  body.heroku .cloud-ui-nav-root:before {
    top: ${currentTheme.herokuBannerHeight};
  }
  body.heroku .cloud-ui-nav-chrome.header {
    top: ${currentTheme.herokuBannerHeight};
  }
  body.heroku .cloud-ui-nav-chrome.sidebar {
    top: ${currentTheme.TopNav.heightWithHerokuBanner};
  }
  body.heroku .ui.popup.cloud-ui-nav-popup.bottom.right {
    margin-top: ${currentTheme.herokuHeaderPopupOffset} !important;
  }

  .no-common-chrome {
    padding-left: ${currentTheme.SideNav.oldWidth};
    padding-top: ${currentTheme.TopNav.oldHeight};
  }

  .cloud-ui-nav-chrome {
    background: ${currentTheme.CommonNav && currentTheme.CommonNav.background};
  }

  .cloud-ui-page-content {
    background-color: ${currentTheme.background};
    color: ${currentTheme.CommonNav && currentTheme.color};
    position: relative;
    height: calc(100vh - ${currentTheme.TopNav.height});
  }
  .cloud-ui-nav-popup {
    background: ${currentTheme.CommonNav &&
      currentTheme.CommonNav.popup.background} !important;
    color: ${currentTheme.CommonNav &&
      currentTheme.CommonNav.popup.color} !important;
  }
  .cloud-ui-nav-menu-divider {
    border-bottom-color: ${currentTheme.CommonNav &&
      currentTheme.CommonNav.color} !important;
  }
  .cloud-ui-nav-menu-link.is-active {
    background: ${currentTheme.CommonNav &&
      currentTheme.CommonNav.popup.activeBackground} !important;
    color: ${currentTheme.CommonNav &&
      currentTheme.CommonNav.popup.activeColor} !important;
  }

  .ui.page.dimmer {
    &&& {
      background-color: rgba(17, 17, 17, 0.6);
    }
  }

  .cloud-ui-nav-root::before,
  .cloud-ui-nav-chrome.header {
    z-index: ${currentTheme.zIndexes.topNavBar};
    background: ${currentTheme.CommonNav && currentTheme.CommonNav.background};
  }

  .cloud-ui-nav .nav-link {
    background: ${currentTheme.CommonNav && currentTheme.CommonNav.background};
    color: ${currentTheme.CommonNav && currentTheme.CommonNav.color};
  }
  .cloud-ui-nav .cloud-ui-search-notice {
    color: ${currentTheme.CommonNav && currentTheme.CommonNav.secondaryColor};
  }
  .cloud-ui-nav .cloud-ui-search-bar,
  .cloud-ui-nav .cloud-ui-search-results,
  .cloud-ui-nav .cloud-ui-search-result {
    background: ${currentTheme.CommonNav && currentTheme.CommonNav.background};
    color: ${currentTheme.CommonNav && currentTheme.CommonNav.color};
  }
  .cloud-ui-search-select-wrapper:hover {
    background: ${currentTheme.CommonNav && currentTheme.CommonNav.hover};
  }
  .cloud-ui-nav .nav-link.is-active,
  .cloud-ui-nav .cloud-ui-search-header {
    background: ${currentTheme.CommonNav && currentTheme.CommonNav.hover};
    color: ${currentTheme.CommonNav && currentTheme.CommonNav.color};
  }
  .cloud-ui-nav .current-user,
  .cloud-ui-nav .current-organization,
  .cloud-ui-nav-chrome .cloud-ui.icon::before {
    color: ${currentTheme.CommonNav && currentTheme.CommonNav.color};
  }
  .cloud-ui-nav-chrome.sidebar .toggle {
    border: ${currentTheme.CommonNav && currentTheme.CommonNav.border};
  }

  /*
    temporary workaround for breadcrumb overflow issues that
    will eventually be addressed in cloud-ui's CommonChrome
  */
  .cloud-ui-nav .ui.breadcrumb {
    display: flex;
    white-space: nowrap;
    width: 1px;
  }
  .cloud-ui-nav .ui.breadcrumb .section:last-child {
    color: ${currentTheme.CommonNav && currentTheme.CommonNav.color};
    flex: 1 1 auto;
    margin-bottom: -3px;
    overflow: hidden;
    padding-bottom: 3px;
    text-overflow: ellipsis;
  }

  body.no-scroll {
    overflow: hidden;
  }

  body * {
    box-sizing: border-box;
  }

  #root {
    position: relative;
  }

  a {
    color: ${currentTheme.link};
    cursor: pointer;
    text-decoration: none;
  }

  /* until cloud icons include lab */
  i.cloud-ui.icon.lab {
    font-family: Icons !important;
  }

  /* temporary workaround until CommonChrome side nav menus don't overflow */
  .ui.popup.cloud-ui-nav-popup.sidebar > .content {
    max-height: calc(min(100vh - 100px, 440px));
  }
`;
